import '@aofl/drawer';

export default (ctx, html) => html`
  <div id="wrapper">
    <div id="label" @click="${(e) => ctx.toggle(e)}" role="button" tabindex="1" data-bi-id="${ctx.dataBiId}">
      <div id="toggle-wrapper" class="${ctx.open ? 'open' : ''}"">
        <slot tabIndex="-1" name="dropdown-toggle">Select</slot>
      </div>
    </div>
    <div id="drawer-wrapper">
      <aofl-drawer ?open="${ctx.open}" opening="slide-down" closing="slide-up">
        <slot name="dropdown-menu"></slot>
      </aofl-drawer>
    </div>
  </div>
  <template class="slide-up slide-down animate dd-align-right dd-align-center"></template>
`;
